import { render, staticRenderFns } from "./BankToSafeForm.vue?vue&type=template&id=5478cbad"
import script from "./BankToSafeForm.vue?vue&type=script&lang=js"
export * from "./BankToSafeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports